import { render, staticRenderFns } from "./OcupationalPagination.vue?vue&type=template&id=42ef1557&"
import script from "./OcupationalPagination.vue?vue&type=script&lang=js&"
export * from "./OcupationalPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports